const monthlyProgressReportsContext = require.context(
  "../../../assets/achievements/monthly_progress_reports",
  false,
  /\.pdf$/i,
);
const overallAchievementsContext = require.context(
  "../../../assets/achievements/overall_achivements",
  false,
  /\.pdf$/i,
);
const populationDisbursementContext = require.context(
  "../../../assets/achievements/population_wise_comulative_disburesement",
  false,
  /\.pdf$/i,
);
const stateAchievementContext = require.context(
  "../../../assets/achievements/state _wise_achievement",
  false,
  /\.pdf$/i,
);
const yearAchievementContext = require.context(
  "../../../assets/achievements/year_wise_achivement",
  false,
  /\.pdf$/i,
);
const yearDisbursementContext = require.context(
  "../../../assets/achievements/year_wIse_disburesment_details",
  false,
  /\.pdf$/i,
);

const monthOrder = {
  jan: 1,
  feb: 2,
  mar: 3,
  apr: 4,
  may: 5,
  jun: 6,
  june: 6,
  jul: 7,
  july: 7,
  aug: 8,
  sep: 9,
  sept: 9,
  september: 9,
  oct: 10,
  nov: 11,
  dec: 12,
};

const compareMonthlyReports = (first, second) => {
  const firstParts = first.fileName.replace(/\.pdf$/i, "").split(" ");
  const secondParts = second.fileName.replace(/\.pdf$/i, "").split(" ");
  const firstYear = Number(firstParts.at(-1));
  const secondYear = Number(secondParts.at(-1));
  const firstMonth = monthOrder[firstParts[0].toLowerCase()] || 0;
  const secondMonth = monthOrder[secondParts[0].toLowerCase()] || 0;

  return secondYear - firstYear || secondMonth - firstMonth;
};

const compareYearDocuments = (first, second) => {
  const firstYear = Number(first.fileName.match(/^\d{4}/)?.[0] || 0);
  const secondYear = Number(second.fileName.match(/^\d{4}/)?.[0] || 0);

  return secondYear - firstYear;
};

const getDocuments = (context, compareDocuments, fileNames = {}) =>
  context
    .keys()
    .map((key) => ({
      fileName: fileNames[key] || key.replace("./", ""),
      href: context(key),
    }))
    .sort(
      compareDocuments || ((first, second) =>
        first.fileName.localeCompare(second.fileName, undefined, {
          numeric: true,
        })),
    );

const achievementDocuments = [
  {
    id: "monthly-progress-reports",
    title: "Monthly Progress Reports",
    documents: getDocuments(monthlyProgressReportsContext, compareMonthlyReports, {
      "./MPR MAY.PDF": "May 2026.pdf",
      "./MPR JUNE.PDF": "June 2026.pdf",
      "./MPR SEPTEMBER.PDF": "September 2026.pdf",
    }),
  },
  {
    id: "overall-achievements",
    title: "Overall Achievements",
    documents: getDocuments(overallAchievementsContext),
  },
  {
    id: "population-wise-cumulative-disbursement",
    title: "Population wise Cumulative Disbursement",
    documents: getDocuments(populationDisbursementContext),
  },
  {
    id: "state-wise-achievement",
    title: "State Wise Achievement",
    documents: getDocuments(stateAchievementContext),
  },
  {
    id: "year-wise-achievement",
    title: "Year Wise Achievement",
    documents: getDocuments(yearAchievementContext),
  },
  {
    id: "year-wise-disbursement-details",
    title: "Year Wise Disbursement Details",
    documents: getDocuments(yearDisbursementContext, compareYearDocuments),
  },
];

// Give every report a descriptive title independent of its filename.
const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
achievementDocuments.forEach((section) => {
  section.documents = section.documents.map((document) => {
    const period = document.fileName.replace(/\.pdf$/i, "");
    let title = section.title;
    if (section.id === "monthly-progress-reports") {
      const [month, year] = period.split(/\s+/);
      title = "Monthly Progress Report - " + (monthNames[monthOrder[month.toLowerCase()] - 1] || month) + " " + year;
    } else if (section.id === "year-wise-disbursement-details") {
      title = "Year-wise Disbursement Details - " + period;
    }
    return { ...document, title };
  });
});

export const getAchievementSection = (section) =>
  achievementDocuments.find((item) => item.id === section) || achievementDocuments[0];

export default achievementDocuments;
